/*
 * Client-side configuration settings
 */



const scripts = document.getElementsByTagName("script");
const thisScriptPath = scripts[scripts.length - 1].src;
const cdnScriptPath = thisScriptPath.substring(0, thisScriptPath.lastIndexOf("/js/") + 1) + "cdnconfig.js";

const config = {
  appName: 'TalentForms',
  gatewayTokenUrl: '/Escher/Escher_WebUI/GatewayToken',
  formsApiBase: 'http://localhost/TalentFormsApi/',
  publicFormsApiBase: 'http://localhost/TalentFormsApi/',

  // note: GA_TRACKING_ID is a token used to replace correct GA token in octopus script
  googleAnalyticsTrackingId: 'GA_TRACKING_ID',
  cdnConfigPath: cdnScriptPath,

  // The following settings will only be included in local (non-production) builds

};



export default config;